import VisualizeVocabularies from '../components/course/visualize-vocabularies';
<template><VisualizeVocabularies @model={{@model}} /></template>
